var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAwDeatail07DidLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 43,
    viewBox: "0 0 47 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4999 42.0535C22.9722 42.053 22.4663 41.843 22.0934 41.4696L4.12746 23.4506C1.69625 20.9703 0.334473 17.6356 0.334473 14.1624C0.334473 10.6893 1.69625 7.35456 4.12746 4.87423C6.59092 2.41102 9.93195 1.02722 13.4156 1.02722C16.8993 1.02722 20.2403 2.41102 22.7038 4.87423L23.4999 5.56421L24.243 4.82116C25.461 3.58981 26.9119 2.61311 28.511 1.94792C30.1102 1.28274 31.8257 0.942385 33.5577 0.946664C35.2878 0.938913 37.0022 1.2751 38.6013 1.93568C40.2004 2.59626 41.6522 3.56807 42.8724 4.79462C45.3036 7.27495 46.6654 10.6096 46.6654 14.0828C46.6654 17.5559 45.3036 20.8906 42.8724 23.371L24.9064 41.39C24.7285 41.5893 24.5123 41.7508 24.2707 41.8648C24.029 41.9788 23.7669 42.0429 23.4999 42.0535Z",
    fill: "#00668C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwDeatail07DidLikeIcon);
export default __webpack_public_path__ + "static/media/aw-deatail-07-did-like-icon.1c959281a26cd189c5e0387a219e46e2.svg";
export { ForwardRef as ReactComponent };